import { useQuery } from '@tanstack/react-query';
import type { AzdoRepository } from '../../api/azdo-lookup';
import { azdoLookupApi } from '../../api/azdo-lookup/client';
import { useWithAccessToken } from '../../auth/use-with-access-token';

export interface UseProjectRepositoriesResult {
  repositories: AzdoRepository[];
  loading: boolean;
  error: string | null;
}

export const useProjectRepositories = (projectId: string | null): UseProjectRepositoriesResult => {
  const queryFn = useWithAccessToken((config) =>
    azdoLookupApi.listProjectRepositories(projectId ?? '', config),
  );
  const query = useQuery({
    queryKey: ['azdo', 'repositories', projectId],
    queryFn: async () => (await queryFn()).data,
    enabled: Boolean(projectId),
  });
  return {
    repositories: query.data ?? [],
    loading: query.isFetching,
    error: query.error ? (query.error as Error).message : null,
  };
};
